<script setup lang="ts">
import {
  APP_VERSION,
  MINIMUM_WINDOWS_VERSION,
  PRODUCT_NAME,
  PRODUCT_SCOPE_LABEL
} from '@bf/domain'
import { runtimeConfig } from '../platform/runtime'
import { useShowroomStore } from '../store/showroom'

const store = useShowroomStore()
</script>

<template>
  <section class="status-view">
    <div class="status-hero">
      <span class="status-large-dot"></span>
      <div>
        <p class="eyebrow">SYSTEM STATUS</p>
        <h2>{{ runtimeConfig.label }}已就绪</h2>
        <p v-if="runtimeConfig.mode === 'desktop'">
          当前内容随应用本地提供；支持基线为 Windows 10 及以上，并使用系统
          WebView2 运行时。
        </p>
        <p v-else-if="runtimeConfig.mode === 'mobile-public'">
          当前为手机 H5 客户版，可通过 HTTPS 链接或二维码在微信、企业微信和手机浏览器中打开。
        </p>
        <p v-else>
          企业微信 H5 依赖网络和服务端会话；断网时请切换 Windows 离线端。
        </p>
      </div>
    </div>

    <dl class="status-grid">
      <div>
        <dt>软件名称</dt>
        <dd>{{ PRODUCT_NAME }}</dd>
      </div>
      <div>
        <dt>程序版本</dt>
        <dd>v{{ APP_VERSION }}</dd>
      </div>
      <div>
        <dt>业务范围</dt>
        <dd>{{ PRODUCT_SCOPE_LABEL }}</dd>
      </div>
      <div v-if="runtimeConfig.mode === 'desktop'">
        <dt>最低系统</dt>
        <dd>{{ MINIMUM_WINDOWS_VERSION }}</dd>
      </div>
      <div>
        <dt>内容版本</dt>
        <dd>{{ store.state.manifest?.contentVersion }}</dd>
      </div>
      <div>
        <dt>运行终端</dt>
        <dd>{{ runtimeConfig.mode }}</dd>
      </div>
      <div>
        <dt>内容渠道</dt>
        <dd>{{ store.state.manifest?.channel }}</dd>
      </div>
      <div>
        <dt>内容数量</dt>
        <dd>{{ store.state.manifest?.entities.length }}</dd>
      </div>
      <div>
        <dt>当前身份</dt>
        <dd>{{ store.state.session?.displayName }}</dd>
      </div>
    </dl>

    <div class="warning-note">
      当前内容包为开发样板，只用于验证流程。正式材料必须通过技术审核、授权和 OT
      脱敏检查。
    </div>
  </section>
</template>
